import { computed } from 'vue';
import { ValidationProperties } from '@/models/validation.interface';
import { LoadingStatuses } from '@/models/loading.interface';
import validationPresenter from '@/presenters/validation-presenter';
import store from '@/store';

export default class CrmRegionWrapperCode {

	public validationMessage = computed((): string => {
		if (this.isFieldValidatedAndInvalid.value) {
			return 'This field must be a positive number with no more than five digits';
		}

		return 'This field must be completed before proceeding';
	});

	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPrimaryData();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public isFieldValidatedAndMissing = computed((): boolean => {
		return validationPresenter.isPropertyMissing(ValidationProperties.CRM_ID);
	});

	public isFieldValidatedAndInvalid = computed((): boolean => {
		return validationPresenter.isPropertyInvalid(ValidationProperties.CRM_ID);
	});
}
